import UserTable from "../../components/Table/User/UserTable";
import { ItemProps, useItems } from "../../hooks/useFetch";
import Table from "../../layouts/Table";
import React, { useMemo, useRef, useState } from "react";
import { IUser } from "../../types/userType";

const AllUsers = () => {
  const [page, setPage] = useState<number>(1);

  const item = useRef([]);
  const ops = useMemo<
    Partial<ItemProps>
  >(() => {
    return { type: "user", all: true, page };
  }, [page]);

  const [users, length, loading] = useItems<IUser>(item.current, ops);

  return (
    <Table
      loading={loading}
      title="User"
      icon="fas fa-user"
      theme={"light"}
      total={length}
      iconColor="text-orange-500"
      onPageChange={(page) => setPage(page)}
    >
      <UserTable data={users}></UserTable>
    </Table>
  );
};

export default AllUsers;
